export default __webpack_public_path__ + "static/poster-a632e234e0af9a6454db131e6921b7ef.png";